import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared/shared.module';
import { CobrancaRoutingModule } from './cobranca-routing.module';
import { CobrancaPesquisaComponent } from './cobranca-pesquisa.component';
import { CobrancaListagemComponent } from './cobranca-listagem.component';
import { CobrancaDetalheComponent } from './cobranca-detalhe.component';


@NgModule({
  imports: [
    SharedModule,
    CobrancaRoutingModule,
  ],
  declarations: [
    CobrancaPesquisaComponent,
    CobrancaListagemComponent,
    CobrancaDetalheComponent
  ]
})
export class CobrancaModule { }
